import { TaskLabel } from '@seen/core/models/taskLabel/taskLabel'
import { cn } from '@seen/ui'
import type { ReactNode } from 'react'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function LabelCircles({ labels }: { labels: string[] }): ReactNode {
  return (
    <div className={cn('space-x-[-0.28125rem] flex rtl:space-x-reverse')}>
      {labels.slice(0, 3).map((label) => (
        <div
          key={label}
          className="relative rounded-full border border-white bg-white"
        >
          <LabelCircle label={label} />
        </div>
      ))}
    </div>
  )
}

function LabelCircle({
  label: labelReferenceString,
}: {
  label: string
}): ReactNode {
  const { data: label } = useRead(TaskLabel, labelReferenceString)
  return <LabelColor color={label?.color} />
}
